// @ts-nocheck
import React from 'react';
import { URL } from '../../service/Service';

const Price = ({ label, element_value, photo, id }) => {
    const parsedValue = Number.parseFloat(String(element_value ?? '').replace(',', '.'));
    const formattedValue = (Number.isFinite(parsedValue) ? parsedValue : 0).toFixed(2).replace(/\./g, ',');

    return (
        <div className="flex min-h-16 w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
            {photo && <img src={`${URL}/productImage/${id}`} alt={label || 'Produto'} className="h-16 w-20 shrink-0 rounded-xl object-cover" />}
            <span className="font-semibold text-slate-700">{label ? <span data-i18n-ignore="true">{label}</span> : 'Produto'}</span>
            <span className="ml-4 whitespace-nowrap text-xl font-bold text-slate-900">{`${formattedValue} €`}</span>
        </div>
    );
};

export default Price;
